import React from 'react'

import {
  GridRowItemsStyled,
  MultiGridItemStyled,
  PaddingBreakpointTypes,
  SingleGridItemStyled
} from './styles'

interface Props {
  id?: string
  content: JSX.Element[]
  heights?: string[]
  widthPercentages?: string[]
  isImages?: boolean[]
  hasSideImages?: boolean[]
  paddingBreakpoints?: PaddingBreakpointTypes[]
}

export const BlockSpace: React.FC<Props> = ({
  id,
  content,
  heights = ['auto', 'auto'],
  widthPercentages = ['50%', '50%'],
  isImages = [false, false],
  hasSideImages = [false, false],
  paddingBreakpoints = ['sm', 'sm']
}) => {
  return (
    <>
      {content.length === 1 ? (
        <SingleGridItemStyled
          paddingBreakpoint={paddingBreakpoints[0]}
          height={heights[0]}
          {...(id && { id })}
        >
          {content[0]}
        </SingleGridItemStyled>
      ) : (
        <GridRowItemsStyled>
          {content.map((element: JSX.Element, index) => (
            <MultiGridItemStyled
              key={index}
              height={heights[index]}
              width={widthPercentages[index]}
              image={isImages[index]}
              sideimage={hasSideImages[index]}
              paddingBreakpoint={paddingBreakpoints[index]}
            >
              {element}
            </MultiGridItemStyled>
          ))}
        </GridRowItemsStyled>
      )}
    </>
  )
}
